// import { defaultNetworkService } from '../../../../../services/network'
import axios from "axios";
import { takeLatest, call, put, select, all } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../../../utils/queryParams.js";
export const SET_LOADING = "saga/SET_LOADING";
export const FETCH_CURRENT_USER = "saga/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "saga/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_CURRENT_USER_FAILURE = "saga/FETCH_CURRENT_USER_FAILURE";
export const UPDATE_ALL_DATA = "saga/UPDATE_ALL_DATA";
export const UPDATE_ALL_DATA_SUCCESS = "saga/UPDATE_ALL_DATA_SUCCESS";
export const UPDATE_ALL_DATA_FAILURE = "saga/UPDATE_ALL_DATA_FAILURE";
export const FETCH_MEMBERSHIP_UNITS = "saga/FETCH_MEMBERSHIP_UNITS";
export const FETCH_MEMBERSHIP_UNITS_SUCCESS = "saga/FETCH_MEMBERSHIP_UNITS_SUCCESS";
export const FETCH_MEMBERSHIP_UNITS_FAILURE = "saga/FETCH_MEMBERSHIP_UNITS_FAILURE";

// const axios = defaultNetworkService()
export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateAllData: createAction(UPDATE_ALL_DATA),
  fetchLeads: createAction(FETCH_MEMBERSHIP_UNITS)
};
export default function* watchStars() {
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatest(UPDATE_ALL_DATA, updateAllData);
  yield takeLatest(FETCH_MEMBERSHIP_UNITS, getMembershipUnits);
}

let date;

export function* getCurrentUserData(data) {
  yield put({ type: SET_LOADING, payload: true });
  yield put({ type: FETCH_CURRENT_USER_SUCCESS, payload: data.payload.user });

  date = data.payload.date || (yield select(state => state.membershipUnits.currentUser.calendarEndDate));

  let id = yield select(state => state.membershipUnits.currentUser.organization_id);
  let objectId = yield select(state => state.membershipUnits.currentUser.current_object_id);
  let locationId = yield select(state => state.membershipUnits.currentUser.current_location_id);
  let regionId = yield select(state => state.membershipUnits.currentUser.current_region_id);

  let allSagas = [getMembershipUnits(id, objectId, locationId, regionId, date)];
  try {
    yield all(allSagas);
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* updateAllData(month) {
  yield put({ type: SET_LOADING, payload: true });

  date = month.payload;

  let id = yield select(state => state.membershipUnits.currentUser.organization_id);
  let objectId = yield select(state => state.membershipUnits.currentUser.current_object_id);
  let locationId = yield select(state => state.membershipUnits.currentUser.current_location_id);
  let regionId = yield select(state => state.membershipUnits.currentUser.current_region_id);

  let allSagas = [getMembershipUnits(id, objectId, locationId, regionId, date)];
  try {
    yield all(allSagas);
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* getMembershipUnits(id, objectId, locationId, regionId, date) {
  try {
    const res = yield call(
      axios.get,
      queryParams.apiVersion +
        "membership/units" +
        "?organization_id=" +
        id +
        "&location_id=" +
        locationId +
        "&region_id=" +
        regionId +
        "&object_id=" +
        objectId +
        "&date=" +
        date
    );
    yield put({ type: FETCH_MEMBERSHIP_UNITS_SUCCESS, payload: res.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_MEMBERSHIP_UNITS_FAILURE, error });
  }
}
